import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

import * as types from '../../actionTypes';
import type { DmsProvider, FetchDmsProvidersSuccessAction } from '../../types';

const dmsProviderAdapter = createEntityAdapter<DmsProvider>({ selectId: ({ id }) => id });

export const initialState = dmsProviderAdapter.getInitialState();

export type DealerConfigurationIntegrationsDmsProviderReducer = typeof initialState;

const handleFetchDmsProvidersSuccess = (
  state: DealerConfigurationIntegrationsDmsProviderReducer,
  action: FetchDmsProvidersSuccessAction
) => dmsProviderAdapter.setAll(state, action.payload.content);

export default createReducer(initialState, {
  [types.FETCH_DMS_PROVIDERS_SUCCESS]: handleFetchDmsProvidersSuccess,
});
